import { awsPartitionFromUse } from "@p0security/integrations-aws-shared/gov-cloud";
import { existingIamWriteItems } from "@p0security/integrations-aws-shared/install-options";
import {
  rdsSecurityPerimeterInstallCommands,
  rdsSecurityPerimeterTerraform,
} from "@p0security/integrations-aws-shared/policy/rds-security-perimeter";
import { Typography } from "@p0security/ui";

import type { AwsInstaller } from "../types";

const rdsSecurityPerimeterInstructions: AwsInstaller["components"]["rds-security-perimeter"]["instructions"] =
  (context, id, item) => {
    const { vpcId, subnetIds, region, accountId } = item;
    const awsPartition = awsPartitionFromUse(
      context.config,
      id,
      "rds-security-perimeter"
    );
    const subnetIdsArray = subnetIds.split(",").map((s) => s.trim());
    return {
      help: (
        <>
          To install P0 on this account, provision P0&apos;s access using{" "}
          <Typography.Link
            href={`https://${id}.signin.aws.amazon.com/console`}
            target="_blank"
            rel="noopener"
          >
            AWS Cloud Shell
          </Typography.Link>{" "}
          or Terraform:
        </>
      ),
      commands: {
        // TODO: Add IAC commands
        shell: [
          {
            command: rdsSecurityPerimeterInstallCommands(context, {
              awsPartition,
              gcloudServiceAccountId: context.config.base[id]?.serviceAccountId,
              awsAccountId: accountId,
              options: { vpcId, region },
              subnetIds: subnetIdsArray,
            }),
          },
        ],
        iac: [
          {
            command: rdsSecurityPerimeterTerraform(context, {
              awsPartition,
              gcloudServiceAccountId: context.config.base[id]?.serviceAccountId,
              awsAccountId: accountId,
              options: { vpcId, region },
              subnetIds: subnetIdsArray,
            }),
          },
        ],
      },
    };
  };

export const rdsSecurityPerimeterInstaller: AwsInstaller["components"]["rds-security-perimeter"] =
  {
    items: {
      accountId: {
        optionProvider: async ({ config }) => {
          return existingIamWriteItems(config).map(([id, item]) => ({
            id,
            label: item?.label,
          }));
        },
      },
    },
    instructions: rdsSecurityPerimeterInstructions,
  };
